import React from "react";
import { Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { useStore } from "../../../app/stores/store";
import dayjs from "dayjs";

const PrintPayrollPdf = () => {
  const { payrollStore } = useStore();
  const { payrollDataList, employeePayrolData } = payrollStore;

  const handlePrint = () => {
    // if (!!payrollDataList || !!payrollDataList.employeePayrolls) {
    //   console.error("No payroll data available");
    //   return;
    // }

    const doc = new jsPDF();

    // Set document styles
    doc.setFont("helvetica", "bold");

    // Main title
    doc.setFontSize(14);
    doc.text("ACTIVATIONS ADVERTISING PAYROLL", 105, 15, { align: "center" });

    // Format and display cutoff dates
    if (
      employeePayrolData?.startCutoffDates &&
      employeePayrolData?.endCutoffDates
    ) {
      const startDate = dayjs(employeePayrolData?.startCutoffDates).format(
        "MMMM D"
      );
      const endDate = dayjs(employeePayrolData?.endCutoffDates).format(
        "D, YYYY"
      );
      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      doc.text(`${startDate} - ${endDate}`, 190, 15, { align: "right" });
    }

    // Prepare table data from payrollDataList
    const tableData = payrollDataList?.map((employee) => [
      employee.employeeId || "N/A",
      employee.employeeName || "N/A",
      employee.employeeNumber || "N/A",
      employee.basicPay ? formatNumberWithSpace(employee.basicPay) : "0",
    ]);

    // Add the table
    autoTable(doc, {
      startY: 22,
      head: [["EMP ID", "EMPLOYEE NAME", "ACCOUNT NO", "BASIC"]],
      body: tableData,
      headStyles: {
        fillColor: '#F4C342',
        textColor: 'black',
        fontStyle: "bold",
        halign: "center",
      },
      styles: {
        cellPadding: 4,
        fontSize: 10,
        valign: "middle",
        font: "helvetica",
      },
      columnStyles: {
        0: { cellWidth: 20, halign: "center" }, // EMP ID
        1: { cellWidth: 65, halign: "left" }, // EMPLOYEE NAME
        2: { cellWidth: 30, halign: "center" }, // ACCOUNT NO
        3: { cellWidth: 20, halign: "right" }, // BASIC
      },
      margin: { left: 15 },
    });

    // Add total if available
    if (payrollDataList.totalSalary) {
      const finalY = doc.lastAutoTable.finalY + 10;
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text("TOTAL", 140, finalY);
      doc.text(
        formatNumberWithSpace(payrollDataList.totalSalary),
        170,
        finalY,
        { align: "right" }
      );
    }

    // Save the PDF
    doc.save(`Payroll_${dayjs().format("YYYY-MM-DD")}.pdf`);
  };

  // Helper function to format numbers with space as thousand separator
  const formatNumberWithSpace = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };

  return (
    <Button icon={<PrinterOutlined />} onClick={handlePrint}>
      Print
    </Button>
  );
};

export default PrintPayrollPdf;
